import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

import { RootState } from '../../types';

export interface HomeState {
	routename: string;
}

export const state: HomeState = {
	routename: 'home'
};

export const actions: ActionTree<HomeState, RootState> = {
	updateRoutename({ commit }, routename: string) {
		commit('UPDATE_ROUTENAME', routename);
	}
};

export const mutations: MutationTree<HomeState> = {
	UPDATE_ROUTENAME(state, routename: string) {
		state.routename = routename;
	}
};

export const getters: GetterTree<HomeState, RootState> = {};

export const home: Module<HomeState, RootState> = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
